import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PublicLayoutComponent } from "./public-layout.component";
import { RouterModule } from "@angular/router";
import { EdpFooterModule } from "@edp-components/edp-footer/edp-footer.module";
import { EdpPublicHeaderModule } from "@edp-components/edp-public-header/edp-public-header.module";
import { EdpPublicHeaderClearModule } from "@edp-components/edp-public-header-clear/edp-public-header-clear.module";

@NgModule({
    declarations: [PublicLayoutComponent],
    imports: [CommonModule, RouterModule, EdpFooterModule, EdpPublicHeaderModule, EdpPublicHeaderClearModule],
    exports: [PublicLayoutComponent],
})
export class PublicLayoutModule {}
